// DISABLE FOR DEBUGGING
import {enableProdMode, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppComponent} from './app.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ScreeningWidgetComponent} from './widgets/screening-widget/screening-widget.component';
import {AddHttpHeaderInterceptor} from './models/headerInterceptor';
import {ToastrModule} from 'ngx-toastr';
import {AuthComponent} from './auth/auth.component';
import {CookieService} from 'ngx-cookie-service';
import {AuthSsoComponent} from './auth-sso/auth-sso.component';
import {ProcessingListComponent} from './processing-list/processing-list.component';
import {CommonModule, DatePipe, DecimalPipe} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbdModalModule} from './modal/modal.module';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {PipesModule} from './pipes/pipes.module';
import {CriminalGridModule} from './decision-grid/criminal-grid.module';
import {ClientsModule} from './clients-module/clients.module';
import {SharedComponentsModule} from './shared-components-module/shared-components.module';
import {UsersModule} from './users-module/users.module';
import {PropertyModule} from './property-module/property.module';
import {ScreeningModule} from './screening-module/screening.module';
import {PackagesModule} from './packages-module/packages.module';
import {InvoiceModule} from './invoice/invoice.module';
import {ChangePasswordViaTokenComponent} from './auth/change-password-via-token/change-password-via-token.component';
import {PaymentModule} from './shared-components-module/payments/payment.module';
import { AuthService } from './services/auth.service';
import { PmsManagementModule } from './pms-management/pms-management.module';
import { AuditModule } from './audit-module/audit.module';
import { AuditLandingComponent } from './audit-module/audit-landing/audit-landing.component';
import { LeaderboardModule } from './leaderboard-module/leaderboard.module';
import { LeaderboardComponent } from './leaderboard-module/leaderboard/leaderboard.component';
import { PmsManagementComponent } from './pms-management/pms-management/pms-management.component';
import { AlertsWidgetComponent } from './widgets/alerts-widget/alerts-widget.component';
import { DevErrorsWidgetComponent } from './widgets/dev-errors-widget/dev-errors-widget.component';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule } from 'angular-plotly.js';
import { DevUtilsWidgetComponent } from './widgets/dev-utils-widget/dev-utils-widget.component';
import { CrimGridModuleComponent } from './crimgrid-module/crim-grid-module/crim-grid-module.component';
import { StatuteBreakdownPlotComponent } from './crimgrid-module/components/statute-breakdown-plot/statute-breakdown-plot.component';
import { ChargeDataListComponent } from './crimgrid-module/components/charge-data-list/charge-data-list.component';
import { StatuteManagerComponent } from './crimgrid-module/components/statute-manager/statute-manager.component';
import { ChargeOpsModalComponent } from './crimgrid-module/components/charge-ops-modal/charge-ops-modal.component';
import { EmailQueueComponent } from './shared-components-module/email-queue/email-queue.component';
import { DisputeTrackerModule } from './dispute-tracker/dispute-tracker.module';
import { DisputeListComponent } from './dispute-tracker/dispute-list/dispute-list.component';
import { KnowledgeBaseModule } from './knowledge-base-module/knowledge-base.module';

PlotlyModule.plotlyjs = PlotlyJS
enableProdMode();

const routes: Routes = [
  {path: '', component: DashboardComponent},
  {path: 'dispute', component: DisputeListComponent},
  {path: 'dashboard', component: DashboardComponent},
  {path: 'crimgrid', component: CrimGridModuleComponent},
  {path: 'processingList', component: ProcessingListComponent},
  {path: 'login', component: AuthComponent},
  {path: 'changePasswordViaToken', component: ChangePasswordViaTokenComponent},
  // {path: 'changePasswordViaToken/:token', component: ChangePasswordViaTokenComponent},
  {path: 'sso', component: AuthSsoComponent},
  {path: 'emailqueue', component: EmailQueueComponent},
  {path: 'audit', component: AuditLandingComponent},
  {path: 'leaderboard', component: LeaderboardComponent},
  {path: ':token', component: AppComponent},
  {path: 'pms', component: PmsManagementComponent },
];

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ScreeningWidgetComponent,
    AuthComponent,
    AuthSsoComponent,
    ProcessingListComponent,
    ChangePasswordViaTokenComponent,
    PmsManagementComponent,
    AlertsWidgetComponent,
    DevErrorsWidgetComponent,
    DevUtilsWidgetComponent,
    CrimGridModuleComponent,
    StatuteBreakdownPlotComponent,
    ChargeDataListComponent,
    StatuteManagerComponent,
    ChargeOpsModalComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbModule,
    NgbdModalModule,
    AngularEditorModule,
    PipesModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    CriminalGridModule,
    ClientsModule,
    UsersModule,
    SharedComponentsModule,
    PropertyModule,
    ScreeningModule,
    InvoiceModule,
    PackagesModule,
    AuditModule,
    LeaderboardModule,
    DisputeTrackerModule,
    KnowledgeBaseModule,
    RouterModule.forRoot(routes),
    ToastrModule.forRoot({
      positionClass: 'toast-top-left',
      preventDuplicates: true,
    }), // ToastrModule added
    PmsManagementModule,
    PlotlyModule
  ],
  exports: [
    ChargeOpsModalComponent
  ],
  providers: [AuthService,{
    provide: HTTP_INTERCEPTORS,
    useClass: AddHttpHeaderInterceptor,
    multi: true
  },
    CookieService, DatePipe, DecimalPipe],
  bootstrap: [AppComponent]
})
export class DashModule {
}
